import { TextField, TextFieldProps, styled } from '@mui/material';

import React from 'react';

import styles from './TextField.module.scss';

const { borderColor, assertColor, whiteBackground } = styles;

type ITextFieldProps = TextFieldProps & {
	multiLine?: boolean;
	error: boolean;
	showLabel?: boolean;
	helperText: string | null | undefined;
	wordLimit?: number;
	customClass?: boolean;
	positionClass?: string;
	parentClass?: string;
	readOnly?: boolean;
};

const defaultProps = {
	multiLine: false,
	isFilled: false,
	readOnly: false,
};
const RedditTextField = styled((props: any) => (
	<TextField
		InputProps={
			{
				disableUnderline: true,
				readOnly: props?.readOnly,
				...props?.InputProps,
			} as Partial<any>
		}
		slotProps={{
			input: {
				readOnly: props?.readOnly,
			},
		}}
		variant="filled"
		{...props}
	/>
))(() => ({
	'& .MuiFilledInput-root': {
		overflow: 'hidden',
		borderRadius: '4px',
		backgroundColor: whiteBackground,
		border: '1px solid',
		borderColor,
		'&:hover': {
			backgroundColor: 'transparent',
		},
		'&.Mui-focused': {
			backgroundColor: 'transparent',
			borderColor,
		},
		'&.Mui-error': {
			borderColor,
			borderBottomColor: borderColor,
		},
		'&.Mui-error:after': {
			borderColor,
			borderBottomColor: borderColor,
		},
		'&.Mui-error:before': {
			borderColor,
			borderBottomColor: borderColor,
		},
	},
	'& .MuiFormLabel-asterisk': {
		color: assertColor,
	},
	'& .MuiInputBase-input, & .MuiFilledInput-input': {
		textAlign: 'justify',
	},
}));

const TextFieldWithLabel = (
	props: ITextFieldProps & { wordLimit?: number; isFilled?: boolean },
) => {
	const {
		name,
		error,
		helperText,
		placeholder,
		multiLine,
		value,
		showLabel = true,
		onChange,
		onBlur,
		wordLimit,
		customClass,
		positionClass,
		isFilled,
		parentClass,
		readOnly,
	} = props;
	const stringValue = value as string;

	const maxLimitClass = customClass
		? styles['word-limit-top']
		: styles['word-limit'];

	const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (wordLimit && e.target.value.length > wordLimit) {
			e.target.value = e.target.value.slice(0, wordLimit);
		}
	};
	const divClass = parentClass ? { className: `${parentClass}` } : {};
	return (
		<div>
			{multiLine ? (
				<div {...divClass}>
					<RedditTextField
						rows={4}
						{...props}
						InputLabelProps={{
							shrink: !isFilled ? !!showLabel : undefined,
							className: styles['text-label'],
						}}
						name={name}
						placeholder={placeholder}
						multiline
						variant="filled"
						value={value}
						onChange={onChange}
						error={!!error}
						onInput={handleInput}
						helperText={error ? helperText : ''}
						onBlur={onBlur}
						readOnly={readOnly}
					/>
					{wordLimit && (
						<div className={`${maxLimitClass} ${positionClass}`}>
							{stringValue?.length || 0}/{wordLimit}
						</div>
					)}
				</div>
			) : (
				<div {...divClass}>
					<RedditTextField
						{...props}
						InputLabelProps={{
							shrink: !isFilled ? !!showLabel : undefined,
							className: styles['text-label'],
						}}
						placeholder={placeholder}
						onChange={onChange}
						error={!!error}
						value={value}
						variant="filled"
						onInput={handleInput}
						helperText={error ? helperText : ''}
						onBlur={onBlur}
						readOnly={readOnly}
					/>
					{wordLimit && (
						<span className={`${styles['word-limit2']} ${positionClass}`}>
							{stringValue?.length || 0}/{wordLimit}
						</span>
					)}
				</div>
			)}
		</div>
	);
};

TextFieldWithLabel.defaultProps = defaultProps;
export default TextFieldWithLabel;
